import React from 'react'
import Lottie from "lottie-react";
import suitcaseAnimation from "../lottie/last-bag-optimized.json";


const style = {
    height: 600,
  };
  
  const interactivity = {
    mode: "scroll",
    actions: [
      {
        visibility: [0, 0.1],
        type: "stop",
        frames: [0],
      },
      {
        visibility: [0.1, 1],
        type: "seek",
        frames: [20, 75],
      },
    ],
  };


const SuitcaseEnd = () => {

  return (
        <div >
    <Lottie
      animationData={suitcaseAnimation}
      style={style}
      interactivity={interactivity}
    />
    </div>
  )
}

export default SuitcaseEnd